import BaseModel from './BaseModel';
import FileModel from './FileModel';
import UserModel from './UserModel';
import VehicleModel from './VehicleModel';
import DriverCertificationModel from './DriverCertificationModel';

export default class DriverProfileModel extends BaseModel {
  init(data) {
    this.id = data.id || 0;
    this.status = data.status || '';
    this.user = data.user ? new UserModel(data.user) : null;
    this.license_number = data.license_number || '';
    this.license_type = data.license_type || '';
    this.license_state = data.license_state || '';
    this.license_expiration = data.license_expiration || null;
    this.license_document = data.license_document || null;
    this.certifications = (data.certifications || []).map(c => new DriverCertificationModel(c));
    this.assigned_vehicles = (data.assigned_vehicles || []).map(v => new VehicleModel(v));
    this.attachments = (data.attachments || []).map(a => new FileModel(a));
    this.notes = data.notes || '';
  }

  get first_name() {
    return this.user?.first_name || '';
  }

  get last_name() {
    return this.user?.last_name || '';
  }

  get fullName() {
    return this.user?.fullName || '';
  }

  get display_label() {
    return this.fullName || `Driver #${this.id}`;
  }
}
